import { configQuery, interpolate, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

/**
 * Email verification component notifies the user
 * that an email has been sent to their address
 * along with a button to resend the email.
 */
var EmailVerificationComponent = /** @class */ (function (_super) {
    __extends(EmailVerificationComponent, _super);
    function EmailVerificationComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.emailClient = '';
        _this.emailClientURL = '';
        /**
         * Configuration for email clients to show CTA during email verification
         */
        _this.emailClientsConfig = {};
        return _this;
    }
    EmailVerificationComponent.prototype.created = function () {
        var _this = this;
        configQuery('emailClients', function (emailClientsConfig) {
            if (emailClientsConfig) {
                _this.emailClientsConfig = emailClientsConfig;
            }
        });
    };
    Object.defineProperty(EmailVerificationComponent.prototype, "email", {
        get: function () {
            return this.model.email;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailVerificationComponent.prototype, "emailDomain", {
        get: function () {
            var _a;
            var email = this.model.email.split('@');
            return (_a = email.pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailVerificationComponent.prototype, "showEmailClientCTA", {
        get: function () {
            for (var key in this.emailClientsConfig) {
                if (this.emailClientsConfig.hasOwnProperty(key)) {
                    if (this.emailClientsConfig[key].domains.includes(this.emailDomain)) {
                        this.emailClient = key;
                        this.emailClientURL = this.emailClientsConfig[key].url;
                        return true;
                    }
                }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailVerificationComponent.prototype, "instructions", {
        get: function () {
            return interpolate(this.$t('sign-up-step-three.email.instructions'), {
                email: this.email,
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EmailVerificationComponent.prototype, "emailClientText", {
        get: function () {
            return interpolate(this.$t('sign-up-step-three.email-client.open'), {
                emailClient: this.emailClient,
            });
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], EmailVerificationComponent.prototype, "model", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], EmailVerificationComponent.prototype, "verificationEmailClients", void 0);
    EmailVerificationComponent = __decorate([
        Component({
            name: 'corex-email-verification',
        })
    ], EmailVerificationComponent);
    return EmailVerificationComponent;
}(Mixins(MagicConfigMixin)));

export default EmailVerificationComponent;
